import { render, staticRenderFns } from "./AllowedUsersView.vue?vue&type=template&id=44172c4f"
import script from "./AllowedUsersView.vue?vue&type=script&lang=js"
export * from "./AllowedUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports